import React from 'react';
import { Fade, useMediaQuery } from '@mui/material';

export default function PageTransition({ transitionKey, children }) {
  const reducedMotion = useMediaQuery('(prefers-reduced-motion: reduce)');
  if (reducedMotion) return <>{children}</>;

  return (
    <Fade in key={transitionKey} timeout={160}>
      <div>{children}</div>
    </Fade>
  );
}



